import {
  Alert,
  Body,
  Footer,
  Header,
  DevelopmentInfo,
  Navbar,
  useAlerts,
  useUsers,
} from "common";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { navbar } from "app/shared/config";
import { navbarPermissionsHelper } from "app/shared/navbarPermissionsHelper";
import { MainContainer } from "common/components/Main-Container/MainContainer";
import {
  LicenseInfo as MuiLicenseInfo,
  muiXTelemetrySettings,
} from "@mui/x-license";
import ReactGA from "react-ga4";

MuiLicenseInfo.setLicenseKey(window.RUNTIME_CONFIG.muiLicenseKey);
muiXTelemetrySettings.disableTelemetry();

export const App = () => {
  const { alert } = useAlerts();
  const { t } = useTranslation();
  const { loggedInUser, currentUser, accessDenied } = useUsers();

  if (
    currentUser.isLoaded &&
    !accessDenied &&
    window.RUNTIME_CONFIG.gaMeasurementId
  ) {
    ReactGA.initialize(window.RUNTIME_CONFIG.gaMeasurementId);
  }

  const permittedNavbar = useMemo(() => {
    // If /users/me hasn't returned yet,
    // just send back the navbar config as-is.
    if (!currentUser.isLoaded) {
      return navbar.items;
    }
    return navbarPermissionsHelper(navbar.items, currentUser.permissions);
  }, [currentUser]);

  return (
    <>
      <DevelopmentInfo />
      <Header
        logoTitle={t("app.logoTitle")}
        logoSubtitle={t("app.logoSubtitle")}
        userDisplayName={loggedInUser.displayName}
      />
      <Body>
        {currentUser.isLoaded ? (
          <>
            <Navbar menuItems={permittedNavbar} />
            {alert.exists && <Alert />}
            <MainContainer idAttr="project-slug-main" />
          </>
        ) : (
          <>{alert.exists && <Alert />}</>
        )}
      </Body>
      <Footer
        copyrightYear={t("app.copyrightYear")}
        productVersion={window.RUNTIME_CONFIG.productVersion || __APP_VERSION__}
      />
    </>
  );
};
